import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import FileManagerModal from './FileManagerModal';
import Tooltip from 'flarum/common/components/Tooltip';
export default class FileManagerButton extends Component {
  view() {
    return m(Tooltip, {
      text: app.translator.trans('fof-upload.forum.buttons.media')
    }, Button.component({
      className: 'Button fof-upload-button Button--icon',
      onclick: this.fileManagerButtonClicked.bind(this),
      icon: 'fas fa-photo-video'
    }));
  }

  /**
   * Event handler for upload button being clicked
   */
  fileManagerButtonClicked(e) {
    e.preventDefault();

    // Note: FileManagerModal is imported synchronously to avoid chunk ID collision
    // with Flarum core's ReplyComposer (both would get webpack chunk ID 378).
    app.modal.show(FileManagerModal, {
      uploader: this.attrs.uploader
    });
  }
}
flarum.reg.add('fof-upload', 'forum/components/FileManagerButton', FileManagerButton);